module.exports = __webpack_public_path__ + "img/SRM.13dab02d.png";